<template>
  <div class="record">
    <el-dialog title="历史价格"
               :visible.sync="dialogVisible"
               width="992px"
               @close="closeModel">
      <!--                @open="apiMethod" -->
      <div class="main scroll-auto">
        <div class="subtitle">
          <h4>历史价格详情</h4>
        </div>
        <div id="EChartD"
             style="width: 100%; height: 300px;margin-bottom:22px"></div>
        <div class="table">
          <el-table :data="tableData"
                    style="width: 100%"
                    border>
            <el-table-column prop="update_time"
                             label="时间"> </el-table-column>
            <el-table-column prop="name"
                             label="产品名称"
                             show-overflow-tooltip
                             v-if="type == 1"> </el-table-column>
            <el-table-column prop="shop_name"
                             label="卖家店铺"
                             show-overflow-tooltip
                             v-if="type == 2"> </el-table-column>
            <el-table-column prop="name"
                             label="SKU名称"
                             show-overflow-tooltip
                             v-if="type == 3"> </el-table-column>
            <el-table-column prop="sell_price"
                             sortable
                             label="页面价格"> </el-table-column>
            <el-table-column prop="final_price"
                             sortable
                             label="折后价格"> </el-table-column>
            <el-table-column prop="left_price"
                             sortable
                             label="差价"> </el-table-column>
            <el-table-column label="政府价格"
                             sortable
                             prop="plan_price_gov"></el-table-column>
            <el-table-column label="上限价格"
                             sortable
                             prop="plan_price_top"></el-table-column>
            <el-table-column label="下限价格"
                             sortable
                             prop="plan_price_bottom"></el-table-column>

            <el-table-column label="指导价格"
                             sortable
                             prop="plan_price_guiding"></el-table-column>
          </el-table>
        </div>
        <div class="pageSize">
          <el-pagination background
                         v-if="tableData.length>0"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="page"
                         :page-sizes="[10, 20, 30, 40]"
                         :page-size="size"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total">
          </el-pagination>
        </div>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const echarts = require("echarts");
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["url", "pid", 'cid', 'constype','plaid'],
  data () {
    return {
      dialogVisible: true,
      tableData: [],
      total: 0,
      page: 1,
      size: 10,
      type: '',
      x: [],
      y: [],
    };
  },
  computed: {
    ...mapGetters({
      getToken: "getToken",
    }),
  },
  created () {
   console.log(this.pid, this.cid,this.constype,'cid---')
    if (this.$route.params.type == "product") {
      this.type = 1
      console.log( this.type,' this.type')
    } else if (this.$route.params.type == "shop") {
      this.type = 3
    } else if (this.$route.params.type == "sku") {
      this.type = 2
    } else {
      console.log(this.$route.params.type,'this.$route.params.type--')
      this.type = this.constype
    }
    if (this.type) {
      this.getproductDetailchartd()
      this.getproductDetailList()
    }

  },
  mounted () { },
  methods: {
    ...mapActions({
      productDetailList: "detect/productDetailList",
      productDetailchartd: "detect/productDetailchartd",
    }),

    getproductDetailchartd () {
      this.x = []
      this.y = []
      let par = {
        token: this.getToken,
        console_type: this.type,
        url: this.url,
      }
      if (this.$route.params.type == "sku") {
        par.console_plan_id = this.$route.params.id
        par.console_product_id = this.pid
      } else if (this.$route.params.type == "shop") {
        par.console_plan_id = this.plaid
        par.console_product_id = this.pid
      }else if ( this.$route.params.type == "product") {
        par.console_plan_id = this.$route.params.pid
        par.console_product_id = this.$route.params.id
      }
      else {
        par.console_plan_id = this.cid
      }
      this.productDetailchartd(par).then(data => {
        if (data.data.code == 1) {
          if (data.data.data.length > 0) {
            data.data.data.forEach(el => {
              this.x.push(parseInt(el.code))
              if (this.x.length > 1) {
                el.data.forEach(elt => {
                  this.y.push(parseInt(elt.result))
                })
              } else {
                this.y.push(parseInt(el.data[el.data.length - 1].result))
              }
            });
            if (this.x.length > 0 && this.y.length > 0) {
              this.$nextTick(() => {
                this.getRenderer(this.x, this.y)
              })
            }
          }
        } else {
          this.$message.error(data.data.msg);
        }
      })
    },
    getproductDetailList () {
      /* par.console_plan_id = this.plaid
        par.console_product_id = this.pid */
      let par = {
        token: this.getToken,
        console_plan_id: this.$route.params.pid==undefined?this.plaid:this.$route.params.pid,
        console_type: this.type,
        day: 7,
        url: this.url,
        page: this.page,
        size: this.size,
      }
      this.productDetailList(par).then(res => {
        if (res.data.code == 1) {
          this.tableData = res.data.data.data
          this.total = res.data.data.count;
        } else {
          this.$message.error(res.data.msg);
        }

      })
    },
    closeModel () {
      this.$emit("closeModel");
    },
    getRenderer (x, y) {
      echarts.dispose(document.getElementById("EChartD"))
      let EChart = echarts.init(document.getElementById("EChartD"));
      let config = {
        tooltip: {
          show: true,
        },
        grid: {
          x: 60,
          y: 50,
          x2: 60,
          y2: 50,
          backgroundColor: "rgba(0,0,0,0)",
          borderWidth: 1,
          borderColor: "#ccc",
        },
        xAxis: {
          type: "category",
          data: x,
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: true,
          },
        },
        series: [
          {
            data: y,
            type: "line",
            smooth: true,
            /*  itemStyle: {
              normal: {
                label: {
                  show: true,      //开启显示
                  position: 'top', //在上方显示
                  textStyle: {     //数值样式
                    color: 'blue',
                    fontSize: 12
                  }
                }
              }
            } */
          },
        ],
      };
      // 设置参数
      EChart.setOption(config);
    },
    handleSizeChange (val) {
      this.size = val;
      this.getproductDetailList()
    },
    handleCurrentChange (val) {
      this.page = val;
      this.getproductDetailList()
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  padding: 20px;
}
.record {
  .main {
    height: 480px;
  }
  .subtitle {
    margin-bottom: 35px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    h4 {
      padding-left: 20px;
      line-height: 18px;
      position: relative;
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 2px;
        background: #2448ff;
      }
    }
    p {
      color: #666;
      font-size: 14px;
    }
  }
  .pageSize {
    text-align: right;
    margin-top: 20px;
  }
}
</style>